export default __webpack_public_path__ + "static/media/calculatePink.db2bcde8.svg";